<template>
  <div>
    <v-container class="Kanit px-5" grid-list-xs style="padding-bottom: 100px">
      <div style="text-align: center; position: relative" class="py-2 mb-3">
        <div
          v-if="$store.state.redirect"
          style="position: absolute; top: 0px; left: 0px"
        >
          <v-btn @click="query.view = $store.state.redirect" text class="pl-0">
            <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
          </v-btn>
        </div>
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
      </div>
      <div class="text-left">
        <h2 v-if="isCustomerProfile" style="color: #0c4d9d">แก้ไขรหัสผ่าน</h2>
        <h2 v-else style="color: #0c4d9d">ลืมรหัสผ่าน</h2>
      </div>
      <transition name="slidedealer" mode="in-out">
        <div :key="1" class="transition" v-if="step == 1">
          <h3 style="color: grey" class="mb-7">
            กรอกเบอร์โทรศัพท์ที่ลงทะเบียน
          </h3>
          <div class="slide-item">
            <ValidationObserver ref="observer" tag="form">
              <form>
                <ValidationProvider
                  :name="'เบอร์โทรศัพท์'"
                  :rules="'required|min:10'"
                  key="phoneno"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    type="number"
                    large
                    outlined
                    class="mt-4"
                    v-model="input.phoneno"
                    placeholder="เบอร์โทรศัพท์"
                    :error-messages="wrongphone ? wrongphone : errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
              </form>
            </ValidationObserver>
          </div>
          <div @click="saveFirst" v-ripple class="addcartbtn Kanit myshadow">
            <p v-if="!loading">ยืนยัน</p>
            <div v-else>
              <v-progress-circular
                indeterminate
                size="35"
                color="white"
              ></v-progress-circular>
            </div>
          </div>
        </div>
        <div :key="2" class="transition" v-if="step == 2">
          <h3 style="color: grey" class="mb-7">กรอก OTP</h3>
          <div class="slide-item">
            <div class="text-center mx-5">
              <div class="font-weight-bold mb-1">
                กรุณากรอก OTP ที่ได้รับทาง SMS
              </div>
              <div class="mb-2">(Ref: {{ otpref }})</div>
              <ValidationObserver ref="observerotp" tag="form">
                <form>
                  <ValidationProvider
                    name="รหัส OTP"
                    :rules="{
                      required: true,
                      min: 5,
                    }"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      v-model="otp"
                      maxlength="6"
                      :success="wrongotp ? false : valid"
                      :error-messages="wrongotp ? wrongotp : errors"
                      @input="wrongotp = ''"
                      v-uppercase
                      outlined
                      placeholder="OTP: XXXXXX"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    :name="'รหัสผ่าน'"
                    vid="confirmation"
                    :rules="{
                      required: true,
                      min: 6,
                    }"
                    key="password"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      large
                      class="mt-4"
                      outlined
                      v-model="input.password"
                      :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword1 ? 'text' : 'password'"
                      @click:append="showPassword1 = !showPassword1"
                      placeholder="รหัสผ่านใหม่"
                      :error-messages="errors"
                      :valid="valid"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    :name="'ยืนยันรหัสผ่าน'"
                    :rules="{
                      required: true,
                      min: 6,
                      confirmed: 'confirmation',
                    }"
                    key="confirmation"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      large
                      class="mt-4"
                      outlined
                      v-model="input.confirmpassword"
                      type="password"
                      placeholder="ยืนยันรหัสผ่านใหม่"
                      :error-messages="errors"
                      :valid="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </form>
              </ValidationObserver>
              <!-- <a :style="sendedOtp?`color: grey`:''" @click="resendOtp">
                Resend OTP
                <div>(ขอส่งใหม่ได้ทุก 60 วินาที)</div>
              </a>-->
              <div
                @click="verifyOTP"
                v-ripple
                class="addcartbtn Kanit myshadow"
              >
                <p v-if="!loading">ยืนยัน</p>
                <div v-else>
                  <v-progress-circular
                    indeterminate
                    size="35"
                    color="white"
                  ></v-progress-circular>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      input: {
        phoneno: "",
        password: "",

        confirmpassword: "",
      },
      showPassword1: false,
      loading: false,
      otpref: "",
      wrongphone: "",
      otp: "",
      wrongotp: "",
      sendedOtp: false,
      transitionname: "slidedealer",
      step: 1,
      saveloading: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    isCustomerProfile() {
      return this.$store.state.redirect == "CustomerProfile" ? true : false;
    },
  },
  mounted() {
    if (this.query.phoneno) {
      this.input.phoneno = this.query.phoneno;
    }
  },
  methods: {
    async saveFirst() {
      if (!this.loading) {
        var vm = this;
        var isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.loading = true;
          var data = {
            userid: this.$store.state.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            phone_number: this.input.phoneno,
          };
          axios
            .patch(
              "https://communitybotbyzwizai.herokuapp.com/toaforgetpassword",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              vm.loading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                vm.otpref = response.data.data[0].reference;
                vm.step = 2;
              } else {
                vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
              }
            })
            .catch(async (err) => {
              await vm.$swal.fire({
                icon: "error",
                text: err.message,
              });
            });
        }
      }
    },
    async verifyOTP() {
      if (!this.loading) {
        var vm = this;
        var isValid = await this.$refs.observerotp.validate();
        if (isValid) {
          this.loading = true;
          var data = {
            userid: this.$store.state.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            phone_number: this.input.phoneno,
            reference: this.otpref,
            password: this.input.password,
            otp: this.otp,
          };
          axios
            .patch(
              "https://communitybotbyzwizai.herokuapp.com/toaresetpassword",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              vm.loading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await vm.$swal.fire({
                  icon: "success",
                  text: "คุณได้เปลี่ยนรหัสผ่านสำเร็จ",
                });
                vm.query.view = "Login";
              } else {
                vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
              }
            });
        }
      }
    },
  },
};
</script>